import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import Login from './pages/auth/Login';
import SEOStudio from './pages/seo-studio';
import AnalyticsHub from './pages/analytics-hub';
import TemplateLibrary from './pages/template-library';
import ContentEditor from './pages/content-editor';
import SettingsCentral from './pages/settings-central';
import DashboardHome from './pages/dashboard-home';
import PageManager from './pages/page-manager';
import VersionControl from './pages/version-control';
import HomePage from './pages/home';
import PrivacyPolicyPage from './pages/privacy-policy';

import ResellerPortal from './pages/reseller-portal';
import ResellerWebsites from './pages/reseller-websites';
import ResellerClients from './pages/reseller-clients';
import MediaLibrary from './pages/media-library';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          {/* Protected routes - Super Admin & regular users */}
          <Route path="/dashboard-home" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
          <Route path="/seo-studio" element={<ProtectedRoute><SEOStudio /></ProtectedRoute>} />
          <Route path="/analytics-hub" element={<ProtectedRoute><AnalyticsHub /></ProtectedRoute>} />
          <Route path="/template-library" element={<ProtectedRoute><TemplateLibrary /></ProtectedRoute>} />
          <Route path="/content-editor" element={<ProtectedRoute><ContentEditor /></ProtectedRoute>} />
          <Route path="/settings-central" element={<ProtectedRoute><SettingsCentral /></ProtectedRoute>} />
          <Route path="/page-manager" element={<ProtectedRoute><PageManager /></ProtectedRoute>} />
          <Route path="/version-control" element={<ProtectedRoute><VersionControl /></ProtectedRoute>} />
          <Route path="/media-library" element={<ProtectedRoute><MediaLibrary onSelect={() => {}} onClose={() => {}} /></ProtectedRoute>} />

          {/* Reseller routes */}
          <Route path="/reseller-portal" element={<ProtectedRoute requiredRole={['reseller', 'super_admin']}><ResellerPortal /></ProtectedRoute>} />
          <Route path="/reseller-websites" element={<ProtectedRoute requiredRole={['reseller', 'super_admin']}><ResellerWebsites /></ProtectedRoute>} />
          <Route path="/reseller-clients" element={<ProtectedRoute requiredRole={['reseller', 'super_admin']}><ResellerClients /></ProtectedRoute>} />

          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
